import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowCircleDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_circle_down"}/>
}
